<template>
  <nav>
    <router-link exact-active-class="on" :to="{ name: 'home' }"><i class="icon-shouye"></i><span>首页</span></router-link>
    <router-link exact-active-class="on" :to="{ name: 'user' }"><i class="icon-yonghu"></i><span>用户中心</span></router-link>
  </nav>
</template>

<script>
export default {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="./tab.css"></style>
